import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';

import { colors, typography } from '../../styles';
import VideoList from '../../components/VideoList';
import AccordionToggle from '../../components/AccordionToggle';

const styles = css`
  position: relative;
  margin-bottom: 126px;
  @media(min-width:992px){
    margin-bottom: 93px;
  }
  .SmothLink_wrapper {
    @media(min-width: 768px) {
      padding: 50px 0;
      position: absolute;
      top: -120px;
      left: 0;
    }
  }
  .Testimonials_title {
    font-family: ${typography.Display};
    font-weight: 700;
    font-size: 24px;
    color: ${colors.color2};
    letter-spacing: 0.67px;
    line-height: 29px;
    margin-bottom: 34px;
    position: relative;
    @media(min-width: 992px) {
      font-size: 26px;
      letter-spacing: 6.19px;
      margin-bottom: 39px;
      max-width: 700px;
    }
  }
  .VideoList_items {
    @media(min-width: 992px) {
      display: flex;
      flex-direction: column;
    }
    .VideoList_wrapper {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      list-style: none;
      padding: 0;
      @media(min-width: 992px) {
        flex-direction: row;
      }
      li{
          width:100%;
      }
      li:first-of-type {
        margin-bottom: 20px;
        @media(min-width: 768px) {
          margin-bottom: 0;
        }
      }
    }
  }
  .AdditionalCopy_link {
    font-size: 18px;
    width: 210px;
    height: 64px;
    border-radius: 32px;
    cursor: pointer;
    margin: auto;
    /* start styles for hover effect */
    display: block;
    padding: 2px;
    overflow: hidden;
    position: relative;
    font-family: ${typography.Display};
    z-index: 0;
    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      width: 125px;
      height: 125px;
      background-color: ${colors.color2};
    }
    &::before {
      left: -125px;
      transform-origin: top right;
      transform: rotateZ(45deg);
      transition: left 250ms ease;
      will-change: left;
    }
    &::after {
      right: -125px;
      transform-origin: top left;
      transform: rotateZ(-45deg);
      transition: right 250ms ease;
      will-change: right;
    }
  }
  .AdditionalCopy_linkInner {
    display: flex;
    color: white;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    border-radius: 30px;
    background-color: ${colors.color1};
    overflow: hidden;
    position: relative;
    z-index: 1;
    font-weight: bold;
  }
  .AdditionalCopy_link:hover {
    &::before {
      left: 18px;
    }
    &::after {
      right: 18px;
    }
  }
  /* end styles for hover effect */
  .Underdog_left{
    &:after{
      background-color: ${colors.color4};
      width: 150px;
    }
  }
`;
const Increment = 4;

class VideoTestimonials extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: Increment,
    };
  }
  showMorePlans = () => {
    this.setState({ limit: this.state.limit + Increment });
  }

  render() {
    const { limit } = this.state;
    const { content } = this.props;
    return (
      <div className={styles}>
        <AccordionToggle
          openOnId="floorplans"
          button={({ contentVisible }) => (
            <div className="">
              <h3 className={`DetailSection_heading ${contentVisible && 'DetailSection_heading-open'}`}>{get(content, 'title')}</h3>
            </div>
          )}
        >
          <div className="VideoList_items container">
            <ul className="VideoList_wrapper">
              {
                get(content, 'video_list').slice(0, limit).map(item => (
                  <li key={item._id}>
                    <VideoList
                      name={get(item, 'name')}
                      title={get(item, 'title')}
                      description={get(item, 'description')}
                      video={get(item, 'video_embed')}
                      thumb={get(item, 'video_thumbnail.contentUrl')}
                      oneVideo={false}
                      one
                    />
                  </li>
                ))
              }
            </ul>
            {
              limit < get(content, 'video_list').length &&
                <div className="AdditionalCopy_link" name="index">
                  <span
                    className="AdditionalCopy_linkInner"
                    role="button"
                    tabIndex="0"
                    onClick={this.showMorePlans}
                    onKeyUp={e => {
                      if (e.key === 'Enter') {
                        this.showPhotos();
                      }
                    }}
                  >
                    Load More
                  </span>
                </div>
            }
          </div>
        </AccordionToggle>
      </div>
    );
  }
}

VideoTestimonials.propTypes = {
  content: PropTypes.object.isRequired,
};

export default VideoTestimonials;



// WEBPACK FOOTER //
// ./src/pages/Testimonials/VideoTestimonials.js